module.exports = __webpack_public_path__ + "static/assets/83857346b7c2e6a351c69377e82a3606.mp3";